export const auth = {
  url: process.env.REACT_APP_AUTH_URL,
  clientAppName: process.env.REACT_APP_CLIENT_APP_NAME,
}